import './style.scss';
import { ReactNode, useState } from 'react';
import { Button } from '@trufla-technology/trumarket-react-design-system';
import { Card } from '@trufla-technology/trumarket-react-design-system';
import { ListActivitiesResponse } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { useReadableDateTime } from '../../hooks/useReadableDateTime';
import { AuditType } from 'app/types/User';

type ClientActivities = Extract<ListActivitiesResponse['data'], object>[number];

type Props = {
  children: ReactNode;
  countLines?: number;
  summary?: ReactNode;
  extra?: JSX.Element[];
  activity?: ClientActivities;
  audit?: AuditType;
  lastItem?: boolean;
};

export const VerticalTimelineItem = ({
  children,
  countLines,
  summary,
  extra,
  activity,
  audit,
  lastItem,
}: Props) => {
  const [expanded, setExpanded] = useState(false);
  const readableDateFormat = useReadableDateTime();

  return (
    <div className={`vertical-timeline-item ${lastItem ? 'last-item' : ''}`}>
      {summary && <div className="summary">{summary}</div>}
      <div className="tru-timeline-activity-status">
        <div className="tru-activities-label-status">
          {activity?.activityType || audit?.type}
        </div>
        <div className="tru-activities-date">
          {activity &&
            readableDateFormat(activity?.createdAt!, 'dd/L/y h:mm a')}
          {audit && readableDateFormat(audit?.createdAt!, 'dd/L/y h:mm a')}
        </div>
      </div>
      <div className="connecter">
        <div className="connector-dot" />
        <div className="horizontal-connector" />
      </div>

      <div className={`card-wrapper ${countLines! > 3 ? 'big-card' : ''}`}>
        <Card type="primary">
          {extra && (
            <Button type="link" onClick={() => setExpanded(!expanded)}>
              {expanded ? '▲' : '▼'}
            </Button>
          )}
          {children}
        </Card>
        {expanded && <div className="sub-items">{extra}</div>}
      </div>
    </div>
  );
};
